<fieldset [ngSwitch]="itemSetting.settingClassName">
  <legend>
    <div>
      <span>{{ getTitle() }}</span>
      <div>
        <eas-editor-booking-item-inheritable-type-badge *ngIf="itemSetting.inheritableType !== 'empty'" [inheritableType]="itemSetting.inheritableType">
        </eas-editor-booking-item-inheritable-type-badge>
        <app-badge *ngIf="itemSettingForm.invalid && itemSettingForm.dirty" variant="danger" title="error" i18n-title></app-badge>
        <button *ngIf="isDeletable()"
          mat-icon-button
          aria-label="Delete setting"
          i18n-aria-label
          (click)="onDelete()">
          <mat-icon inline>delete</mat-icon>
        </button>
      </div>
    </div>
  </legend>
  <p>
    {{ getHelpText() }}
  </p>
  <ng-container *ngSwitchCase="'BookingDate'">
    <eas-editor-booking-item-setting-field-booking-date-start [parentFormGroup]="itemSettingForm">
    </eas-editor-booking-item-setting-field-booking-date-start>
    <eas-editor-booking-item-setting-field-booking-date-end [parentFormGroup]="itemSettingForm">
    </eas-editor-booking-item-setting-field-booking-date-end>
    <eas-editor-booking-item-setting-field-booking-date-timezone [parentFormGroup]="itemSettingForm">
    </eas-editor-booking-item-setting-field-booking-date-timezone>
    <div *ngIf="itemSettingForm.invalid && itemSettingForm.dirty" class="alert alert-danger">
      <div *ngIf="itemSettingForm.errors?.invalidStart" i18n>
        Invalid start date.
      </div>
      <div *ngIf="itemSettingForm.errors?.invalidEnd" i18n>
        Invalid end date.
      </div>
      <div *ngIf="itemSettingForm.errors?.invalidDate" i18n>
        Invalid date.
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'BookingWindow'">
    <eas-editor-booking-item-setting-field-booking-window-open [parentFormGroup]="itemSettingForm">
    </eas-editor-booking-item-setting-field-booking-window-open>
    <eas-editor-booking-item-setting-field-booking-window-close [parentFormGroup]="itemSettingForm">
    </eas-editor-booking-item-setting-field-booking-window-close>
    <eas-editor-booking-item-setting-field-booking-window-timezone [parentFormGroup]="itemSettingForm">
    </eas-editor-booking-item-setting-field-booking-window-timezone>
    <div *ngIf="itemSettingForm.invalid && itemSettingForm.dirty" class="alert alert-danger">
      <div *ngIf="itemSettingForm.errors?.invalidOpen" i18n>
        Invalid open date.
      </div>
      <div *ngIf="itemSettingForm.errors?.invalidClose" i18n>
        Invalid close date.
      </div>
      <div *ngIf="itemSettingForm.errors?.invalidWindow" i18n>
        Invalid window.
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'Capacity'">
    <eas-editor-booking-item-setting-field-capacity-available [parentFormGroup]="itemSettingForm">
    </eas-editor-booking-item-setting-field-capacity-available>
    <div *ngIf="itemSettingForm.invalid && itemSettingForm.dirty" class="alert alert-danger">
      <div *ngIf="itemSettingForm.errors?.invalidAvailable" i18n>
        Invalid capacity.
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'Eligibility'">
    <eas-editor-booking-item-setting-field-eligibility-id [parentFormGroup]="itemSettingForm">
    </eas-editor-booking-item-setting-field-eligibility-id>
    <eas-editor-eligibility-editor-loader
      [eligibilityId]="itemSettingForm.value.id"
      (set)="onCreate($event)"
      (unset)="onDelete()"
    >
    </eas-editor-eligibility-editor-loader>
  </ng-container>
  <ng-container *ngSwitchCase="'Pricing'">
    <eas-editor-booking-item-setting-field-pricing-currency [parentFormGroup]="itemSettingForm">
    </eas-editor-booking-item-setting-field-pricing-currency>
    <eas-editor-booking-item-setting-field-pricing-price [parentFormGroup]="itemSettingForm">
    </eas-editor-booking-item-setting-field-pricing-price>
    <eas-editor-booking-item-setting-field-pricing-methods [parentFormGroup]="itemSettingForm">
    </eas-editor-booking-item-setting-field-pricing-methods>
    <div *ngIf="itemSettingForm.invalid && itemSettingForm.dirty" class="alert alert-danger">
      <div *ngIf="itemSettingForm.errors?.invalidPricing" i18n>
        Invalid pricing.
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'Venue'">
    <eas-editor-booking-item-setting-field-venue-id [parentFormGroup]="itemSettingForm">
    </eas-editor-booking-item-setting-field-venue-id>
    <div *ngIf="itemSettingForm.invalid && itemSettingForm.dirty" class="alert alert-danger">
      <div *ngIf="itemSettingForm.errors?.invalidId" i18n>
        Invalid venue.
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'Workflow'">
    <eas-editor-booking-item-setting-field-workflow-id [parentFormGroup]="itemSettingForm">
    </eas-editor-booking-item-setting-field-workflow-id>
    <eas-editor-workflow-editor-loader
      [workflowId]="itemSettingForm.value.id"
      (set)="onCreate($event)"
      (unset)="onDelete()"
    >
    </eas-editor-workflow-editor-loader>
  </ng-container>
</fieldset>
